import { inject, observer } from "mobx-react";
import React from "react";
import { Route, Switch } from "react-router-dom";
import StartAgents from "./StartAgents";
import StartMessages from "./StartMessages";


@inject((store) => {
    const { authStore } = store

    return {
        authStore
    }
})
@observer
class StartRouter extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {

        const { authStore: { roles } } = this.props
        const authorized =
            roles.includes('admin') ||
            roles.includes('start_manager') ||
            roles.includes('start')

        return authorized ? (
            <Switch>
                <Route exact path="/start/agents" component={StartAgents} />
                <Route exact path="/start/messages" component={StartMessages} />
            </Switch>
        ) : (
            ''
        )
    }
}

export default StartRouter